document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slideshow-component').forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('.slider__slide');

    // Set first slide as active
    if (slides.length) slides[0].classList.add('is-active');

    slideshow.addEventListener('slideChanged', (event) => {
      slides.forEach(slide => slide.classList.remove('is-active'));
      event.detail.currentElement.classList.add('is-active');
    });
  });
});
